<h2 mat-dialog-title class="modal-header">
    Nouveau parcours
</h2>

<mat-dialog-content>
    <form [formGroup]="raceFG" (submit)="submit()" class="form-race-wrapper">

        <mat-form-field appearance="outline">
            <mat-label>Nom du parcours</mat-label>
            <input matInput type="text" formControlName="name">
        </mat-form-field>

        <mat-form-field appearance="outline">
            <mat-label>slug</mat-label>
            <input matInput type="text" formControlName="slug">
            <mat-hint>Lien dans url qui contient le nom du parcours. Exemple: 10k-de-la-mer</mat-hint>
        </mat-form-field>

        <div class="d-flex flex-row justify-content-center p2 gap-3">
            <button matButton="outlined" color="primary" type="button" [mat-dialog-close]="false">Fermer</button>
            <button matButton="filled" color="primary" type="submit" [disabled]="raceFG.invalid">Créer le
                parcours</button>
        </div>

    </form>
</mat-dialog-content>